import {createFileRoute, useRouter} from "@tanstack/react-router"
import {WasteEditor} from "../../waste/editor.tsx";
import {Box, Sheet, Stack} from "@mui/joy";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil} from "@fortawesome/pro-regular-svg-icons";
import {faBoxOpen} from "@fortawesome/pro-regular-svg-icons/faBoxOpen";
import {WasteFlavorStub} from "../../rpc/webrpc-client.gen.ts";
import {useState} from "react";
import {useShowableWasteFlavors} from "../../wasteFlavor/wasteFlavor.tsx";
import {PageBody, PageHeader, PageShell} from "../../routing/shell.tsx";
import {TopBar} from "../../components/TopBar.tsx";
import z from "zod/v4";

export const NewWastePageSearchProps = z.object({
    bundleId: z.string(),
});
export type NewWastePageSearchProps = z.infer<typeof NewWastePageSearchProps>;

function NewWastePage() {
    const {bundleId} = Route.useSearch();
    const {data: flavors} = useShowableWasteFlavors();
    const [flavor, setFlavor]
        = useState<WasteFlavorStub | null>(null);

//    const navigate = useNavigate();
    // const sendToTimelineForPhotos = useCallback(({waste}: { waste: Waste }) => {
    //     void navigate({
    //         to: wasteRoute.to,
    //         params: {id: waste.id},
    //         search: {facet: "timeline"},
    //         replace: true,
    //     });
    // }, [navigate]);

    const router = useRouter();
    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>
                <Stack direction="row"
                       sx={{
                           alignItems: "center",
                           justifyContent: "space-between",
                           bgcolor: "primary.softBg",
                           color: "primary.softColor",
                           px: 1.4,
                       }}>
                    <Sheet color="primary" variant="solid" invertedColors={true} sx={{p: 1}}>
                        <FontAwesomeIcon icon={faBoxOpen} size="2x"/>
                    </Sheet>
                    <Stack direction="row" sx={{flex: 1, justifyContent: "center"}}>
                        {flavor
                            ? <Box sx={{fontSize: "lg"}}>{flavor.displayName}</Box>
                            : null}
                    </Stack>
                    <Sheet color="primary" variant="solid" invertedColors={true} sx={{p: 1}}>
                        <FontAwesomeIcon icon={faPencil} size="2x"/>
                    </Sheet>
                </Stack>
            </Stack>
        </PageHeader>
        <PageBody>
            <WasteEditor bundleId={bundleId} mode="rw"
                         possibleFlavors={flavors}
                         onFlavorChange={(newFlavor) => {
                             setFlavor(newFlavor);
                         }}
                         afterSpawn={() => {
                             router.history.back();
                         }}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/waste-new")({
    component: NewWastePage,
    validateSearch: (search: Record<string, unknown>) => {
        return NewWastePageSearchProps.parse(search);
    },
})

export const r2 = Route.to;
